<template>
 <div class="gallery-bar-wrapper">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center gallery-bar">
          <h6 class="mb-0 mr-3">{{ title }}</h6>
          <PriceListButton v-if="hasPriceList" @click="showPriceList"/>
        </div>
      </div>
      <div class="separator mx-auto"></div>
    </div>
</template>


<script>
import PriceListButton from "@/domain/galleries/components/PriceListButton.vue";

export default {
  name: "HeaderBar",
  components: {PriceListButton},
  emits: ['show-price-list'],
  props: {
    title: {
      type: String,
      required: true
    },
    hasPriceList: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showPriceList() {
      this.$emit('show-price-list')
    }
  }
}
</script>


<style scoped>

</style>